import { Location } from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DefaultComponent} from "../../shared/components/default.component";
import {IonModal, LoadingController, ToastController} from "@ionic/angular";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {time} from "ionicons/icons";

@Component({
  selector: 'app-activate',
  templateUrl: './activate.page.html',
  styleUrls: ['./activate.page.scss'],
})
export class ActivatePage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
    isLoading = false;
    authForm: FormGroup;
    key: any;
    public isActive: boolean = false;
    public activated: boolean = false;


  constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
      toastController: ToastController
  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
  }





  ngOnInit() {
    this.key = this.activatedRoute.snapshot.paramMap.get('key');
    console.log(this.key);

  }

  activateAccount() {
    this.isLoading = true;
    const queryParams = {
        token : this.key
      }
    this.authenticationService.activate(queryParams).subscribe(
        (response) => {
          this.isLoading = false;
          this.activated = true;
          setTimeout(() => {
            this.router.navigate(['private/authentication/login']);
          }, 2000); // 2000ms = 2
          },
        (error) => {
          this.isLoading = false;
            this.isActive = true;
            setTimeout(() => {
                this.router.navigate(['private/authentication/login']);
            }, 2000); // 2000ms = 2
        }
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }



}
